import * as firebase from 'firebase'

// Evaluations module

const state = {
  userEvaluations:[],
};

const mutations = {
  // Add User Evaluation
  addUserEvaluation(state, payload) {
    state.userEvaluations.push(payload)
  },
  // Set User Evaluations on Login
  setUserEvaluations(state, payload) {
    state.userEvaluations = payload
  },
  // Remove User Evaluation Writer
  removeUserEvaluation(state, payload) {
    state.userEvaluations.forEach(writer => {
      if(writer.id === payload) {
        state.userEvaluations.splice(state.userEvaluations.indexOf(writer), 1)
      }
    })
  },
     // Logout Colleges
     setLogoutUser(state, payload = null) {
      state.userEvaluations = []
      
    },
};

const actions = {
   // Add User Evaluation Writer to database and commit to addUserEvaluation mutation
   setEvaluationWriter({commit, getters}, payload) {
    firebase.database().ref('/users/' + getters.user.uid + '/evaluations/').push(payload)
    .then((data) => {
      const key = data.key
      commit('addUserEvaluation', {
        ...payload,
        id:key
      })
    })
  },
  // Edit User Evaluation Writer
  setEditEvaluationWriter({commit, getters}, payload) {
    firebase.database().ref('/users/' + getters.user.uid + '/evaluations/' + payload.id).update({writer_email: payload.writer_email, writer_name : payload.writer_name, writer_title: payload.writer_title, writer_time_known: payload.writer_time_known, writer_phone: payload.writer_phone, evaluation_status: payload.evaluation_status})
    .then((data) => {
      // const key = data.key
      // commit('editUserEvaluation', {
      //   ...payload,
      //   id:key
      // })
    })
  },
  // Remove User Evaluation Writer
  setRemoveEvaluationWriter({commit, getters}, payload) {
    firebase.database().ref('/users/' + getters.user.uid + '/evaluations/').child(payload).remove()
    .then((data) => {
      commit('removeUserEvaluation', payload)
    })
  },
   // Update Writer Evaluation Status
   setUpdateEvaluationStatus({commit, getters}, payload) {
    firebase.database().ref('/users/' + getters.user.uid + '/evaluations/' + payload.id).update({ evaluation_status: payload.evaluation_status})
    .then((data) => {
      // const key = data.key
      // commit('editUserEvaluation', {
      //   ...payload,
      //   id:key
      // })
    })
  },
};

const getters = {
  // User Evaluations
  userEvaluations(state) {
    return state.userEvaluations
  },
  // writer Info
  writerInfo(state) {
    return (id) => {
      return state.userEvaluations.find((writer) => {
        return writer.id === id
      })
    }
  },
};

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/evaluations.js